import { alpha, Box, styled } from "@mui/material";
import { IStyledChatBottomProps, IStyledComposerProps } from "./types";

// Absolutely positioned on purpose — StyledGlassPanel's backdrop-blur is a "frosted glass" effect that
// needs real scrolling message content directly behind it to blur. Chat/index.tsx (LateralChat) measures
// this element's actual height and feeds it back into Chat.Content's own padding, so it still never
// permanently covers the last message no matter how tall it gets (context banner, attached files...).
const StyledBottom = styled(Box)<IStyledChatBottomProps>(({ theme }) => ({
  position: "absolute",
  padding: theme.spacing(1.5),
  bottom: "0px",
  left: "0px",
  right: "0px",
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
}));

// Groups the context header and the message input into a single seamless
// card: a white "Contextualizado" strip on top flowing directly into the
// dark glass input row below, with no gap between them.
const StyledComposer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasContext",
})<IStyledComposerProps>(({ theme, hasContext }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  ...(hasContext && {
    borderRadius: theme.spacing(2.5),
    overflow: "hidden",
    boxShadow: `0 8px 24px ${alpha((theme as any).palette.neutral.darkest, 0.35)}`,
  }),
}));

const StyledContextSection = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1, 1.5),
}));

export { StyledBottom, StyledComposer, StyledContextSection };
